


//Header with home navigation button included

//Todo: need one with back arrow navigation included

import star from "../../../assets/UI/star.png";
import './Header_Home.css';


export default function HeaderHome() {
  return (
    <div>
        <div className="HomeHeader-hh">
        
        
            {/* Logo */}
            <div className="Logo-hh">
                <img src={star} className="star-hh" alt="Logo Star" />
                <h1 className="LogoTxt1-hh">Hangeul</h1>
                <h1 className="LogoTxt2-hh">Hero</h1>
            </div >
            <p className="Slogan-hh">Learn Korean the fun way!</p>
        </div>
      
      {/* Pink Narrow Banner */}
      <div className="narrow-banner-hh">

        <div className="NarrowBannerElements-hh">

            <div>
                <p className="NarrowBannerHomeTxt-hh">PHONETICS</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-hh">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-hh">FLASHCARDS</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-hh">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-hh">GAMES & ACTIVITIES</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-hh">|</p>
            </div>
 
            <div>
                <p className="NarrowBannerHomeTxt-hh">GRAMMAR</p>
            </div>
        
        </div>
    
    </div>

</div>
        
  )
}
